<template>
    <div id="demo-basic-card" v-show="firstLogin" class="bg-first-login">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="component vx-card md:w-7/12 mx-auto p-8">
                    <div class="component vx-logo cursor-pointer mx-auto flex items-center">
                        <logo class="w-10 mr-4 fill-current text-primary" />
                        <span class="vx-logo-text text-black">InfoCare</span>
                    </div>
                    <div class="component w-full mt-2">
                        <span>{{ textWelcome }}</span>
                        <img src="@/assets/images/pages/confetti.png" alt="" height="20" class="ml-2">
                    </div>
                    <div class="component w-full">
                        <span>{{ info }}</span>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-input v-validate="'required'" data-vv-validate-on="blur" label="Họ và tên" v-model="user.fullName" class="w-full mt-4" placeholder="Nhập họ và tên" name="name"></vs-input>
                            <span class="text-danger text-sm mt-4">{{errors.first("name")}}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-input label="Người giới thiệu" v-model="user.introducer" class="w-full mt-4" placeholder="Nhập tên người bạn biết đến hoặc email người giới thiệu"></vs-input>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-input disabled label="Email" v-model="user.email" class="w-full mt-4" placeholder="email@domain.com" v-validate="'required|email'" name="email"></vs-input>
                            <span class="text-danger text-sm mt-4">{{errors.first("email")}}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-input v-validate="'required|min:10|max:11'" name="phoneNumber" data-vv-validate-on="blur" type="number" label="Số điện thoại" v-model="user.phoneNumber" class="w-full mt-4" placeholder="Nhập số điện thoại"></vs-input>
                            <span class="text-danger text-sm mt-4">{{errors.first("phoneNumber")}}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-input v-validate="'required'" data-vv-validate-on="blur" name="organizationName" label="Công ty/Tổ chức" v-model="user.organization.organizationName" class="w-full mt-4" placeholder="Nhập tên tổ chức"></vs-input>
                            <span class="text-danger text-sm mt-4">{{errors.first("organizationName")}}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-4">
                            <label class="ml-1" for="" style="font-size:12px">Chọn ngành/nghề tổ chức</label>
                            <v-select v-model="selectedPartitive" :options="optionCustomerTypes" class="w-full" placeholder="Chọn bộ phận làm việc của bạn"></v-select>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-4">
                            <label class="ml-1" for="" style="font-size:12px">Bộ phận</label>
                            <v-select v-model="selectedJob" :options="optionalJobs" class="w-full" placeholder="Chọn bộ phận làm việc của bạn"></v-select>
                            <!-- <vs-input label="Nghành" v-model="user.job" class="w-full mt-4" placeholder="Chọn nghành/nghề của tổ chức"></vs-input> -->
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-4">
                            <label class="ml-1" for="" style="font-size:12px">Chọn mục đích sử dụng của bạn</label>
                            <v-select v-model="selectedTarget" :options="optionalTargets" class="w-full" placeholder="Chọn bộ phận làm việc của bạn"></v-select>
                            <!-- <vs-input label="Mục đích sử dụng" v-model="user.target" class="w-full mt-4" placeholder="Chọn mục đích sử dụng của bạn"></vs-input> -->
                        </div>
                    </div>
                    <div class="vx-row mt-4 p-4">
                        <vs-button class="w-full" :disabled="!validateForm" @click="confirmTrialPopup">Bắt đầu</vs-button>
                    </div>
                </div>
            </div>
            <!-- <PopupTrial :active="activePopup" :on-success="onSuccess" :close="closePopup"/> -->
        </div>
    </div>
</template>
<script>
import Logo from '../../../../layouts/components/Logo.vue';
import vSelect from 'vue-select';
import PopupTrial from "../../notify/PopupTrial";
export default {
    components:{
        Logo,
        vSelect,
        PopupTrial
    },
    props:{
        firstLogin:{
            default:false
        }
    },
    data(){
        return {
            textWelcome: 'Chào mừng bạn đến với InfoCare.',
            info: 'Nhập các thông tin dưới đây để bắt đầu sử dụng InfoCare.',
            user: {
                id:null,
                fullName: null,
                organization: {
                    organizationName: null,
                },
                introducer: null,
                email: null,
                phoneNumber: null,
                birthday: null,
                city:null,
                district:null,
                subDistrict: null,
                houseNumber: null,
                fullAddress: null,
                password: null,
                customerType: null,
                job: null,
                target:null
            },
            valueSelectedPartitive: null,
            activePopup:false,
            confirmTrial:false,
            valueSelectedJob: null,
            valueSelectedTarget: null,
            optionCustomerTypes: [
                {label:'Bán lẻ & thương mại', value: 0},
                {label: 'Bảo hiểm', value: 1},
                {label: 'Bất động sản', value: 3},
                {label: 'CNTT & Viễn thông', value: 4},
                {label: 'Dịch vụ công & nhà nước', value: 5},
                {label: 'Dịch vụ vận tải', value: 6},
                {label: 'Dược và Y tế', value: 7},
                {label: 'Fintech', value: 8},
                {label: 'Giải trí', value: 9},
                {label: 'Giáo dục', value: 10},
                {label: 'Giao nhận vận tải', value: 11},
                {label: 'Khách sạn và nhà nghỉ', value: 12},
                {label: 'Làm đẹp, Mỹ phẩm & Sức khoẻ', value: 13},
                {label: 'Luật/Pháp lý', value: 14},
                {label: 'Năng lượng', value: 15},
                {label: 'Nông nghiệp', value: 16},
                {label: 'Quảng cáo/Truyền thông', value: 17},
                {label: 'Tài chính/Ngân hàng', value: 18},
                {label: 'Thực phẩm & Đồ uống', value: 19},
                {label: 'Thương mại điện tử', value: 20},
                {label: 'Tiêu dùng nhanh', value: 21},
                {label: 'Xây dựng', value: 22},
                {label: 'Khác', value: -1},
            ],
            optionalJobs: [
                {label: 'Marketing - Truyền thông', value:0},
                {label: 'PR - Thương hiệu', value: 1},
                {label: 'Chăm sóc khách hàng', value: 2},
                {label: 'Kinh doanh bán hàng', value: 3},
                {label: 'Hành chính nhân sự', value: 4},
                {label: 'IT - Phát triển sản phẩm', value: 5},
                {label: 'Nghiên cứu phát triển (R&D)', value: 6},
                {label: 'Khác', value: -1},
            ],
            optionalTargets: [
                {label: 'Giám sát thương hiệu', value: 0},
                {label: 'Đánh giá hiệu quả chiến dịch', value: 1},
                {label: 'Xử lý khủng hoảng truyền thông', value: 2},
                {label: 'Chăm sóc khách hàng', value: 3},
                {label: 'Theo dõi đối thủ cạnh tranh', value: 4},
                {label: 'Nghiên cứu thị trường', value: 5},
                {label: 'Lập chiến lược marketing', value: 6},
                {label: 'Khám phá xu hướng mới', value: 7},
                {label: 'Theo dõi dư luận', value: 8},
                {label: 'Khác', value: -1}
            ]
        }
    },
    computed:{
        validateForm(){
            return !this.errors.any()
        },
        selectedPartitive:{
            get(){
                let object = this.optionCustomerTypes.find(type => type.value === this.valueSelectedPartitive);
                if(!object) return;
                return {
                    label: object.label,
                    value: this.valueSelectedPartitive
                }
            },
            set(object){
                this.valueSelectedPartitive = object ? object.value : null;
            }
        },
        selectedJob:{
            get(){
                let object = this.optionalJobs.find(type => type.value === this.valueSelectedJob);
                if(!object) return;
                return {
                    label: object.label,
                    value: this.valueSelectedJob
                }
            },
            set(object){
                this.valueSelectedJob = object ? object.value : null;
            }
        },
        selectedTarget:{
            get(){
                let object = this.optionalTargets.find(type => type.value === this.valueSelectedTarget);
                if(!object) return;
                return {
                    label: object.label,
                    value: this.valueSelectedTarget
                }
            },
            set(object){
                this.valueSelectedTarget = object ? object.value : null;
            }
        }
    },
    methods: {
      onSuccess(){
      },
      closePopup(){
        this.activePopup = false;
        this.confirmTrial = false;
      },
      confirmTrialPopup () {
          
        this.activePopup = true;
        this.confirmTrial = true;
        this.saveFirstLogin();
      },
      saveFirstLogin: function(){
            const payload = {
                id: this.user.id,
                fullName: this.user.fullName,
                email: this.user.email,
                phoneNumber: this.user.phoneNumber,
                gender: this.user.gender,
                birthday: this.user.birthday,
                organizationName: this.user.organization.organizationName,
                city: this.user.city,
                district: this.user.district,
                subDistrict: this.user.subDistrict,
                houseNumber: this.user.houseNumber,
                fullAddress: this.user.fullAddress,
                password: this.user.password,
                introducer: this.user.introducer,
                department: this.valueSelectedPartitive,
                job: this.valueSelectedJob,
                target: this.valueSelectedTarget,
                firstLogin: 1
            }
            this.$vs.loading();
            this.$business.post('/business-user/update-info', payload).then(() => {
              this.activePopup = false;
              this.confirmDelete = false;
                this.$vs.loading.close();
                this.firstLogin = false;
                location.reload()
                this.onSuccess()
                return this.$vs.notify({
                    text: "Cập nhật thông tin tài khoản thành công",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'primary'
                });
            }).catch((err) => {
                this.activePopup = false;
                this.confirmDelete =false;
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
            })
        },
      initScreen(){
            this.$oauth.get('/user/current').then((response) => {
                let result = response.data;
                this.user = result;
                this.valueSelectedPartitive = parseInt(result.department);
                this.valueSelectedJob = parseInt(result.job);
                this.valueSelectedTarget = parseInt(result.target);
            })
        }
    },
    async created(){
        this.initScreen();
    }
}
</script>
<style scoped>
.bg-first-login {
    height: 100vh;
    z-index: 200000;
    position: fixed;
    top: 0px;
    padding-top: 100px;
    background: rgb(0, 0, 0, 0.2);
    right: 0;
    left: 0;
}
</style>
